/* eslint-disable */
export const StatusEmitterMixin = {
    computed: {
        status() {
            console.log('OVERRIDE COMPUTED - status');
            return {};
        }
    },
    watch: {
        status() {
            this.emitStatus();
        }
    },
    methods: {
        emitStatus() {
            this.$emit('input', this.status);
        }
    },
    created() {
        this.emitStatus();
    }
}
